import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosTextoQuebraEspecial,
    //formataTableCellHeadExibeDadosValorQuebraEspecial,
    formataTableCellBodyExibeDadosTexto,
    formataTableCellBodyExibeDadosTextoIdade,
    formataTableCellBodyExibeDadosValor,
    formataTableCellBodyExibeDadosPerc,
} from '../../../business-components/Formata/Formata'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    GridContainerReport,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    calculaReport,
} from './EstudoService'



const EstudoFormAportePlanejadoAposentadoria = ( { values, estudo, report } ) => {

    const reportPlanejadoAposentadoria = calculaReport(values, report)
    
    const AportePlanejadoAposentadoria = () => {

        let headList = [
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.descricao, reportPlanejadoAposentadoria),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTextoQuebraEspecial(LABEL.mesAnoInicialIdadeQuebraEspecial,
                    reportPlanejadoAposentadoria),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTextoQuebraEspecial(LABEL.mesAnoFinalIdadeQuebraEspecial,
                    reportPlanejadoAposentadoria),
            },
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.tipoPeriodicidadeAporteDividendosAbreviado,
                    reportPlanejadoAposentadoria),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valor, reportPlanejadoAposentadoria),
            },
        ]

        return (
            <DivForm>
                <GridContainerReport>
                    <GridItem12
                        align="center"
                        className={'mb-2 '+ CLASSNAME().formataReportCapacidadePoupancaNecessidadeAporteAposentadoriaCabecalho}
                    >
                        {LABEL.aportePlanejadoAposentadoria}
                    </GridItem12>
                </GridContainerReport>

                <CardGridDivBody>
                    <TableExibeDados
                        report={reportPlanejadoAposentadoria}
                        noMinW={true}
                    >
                        <TableHeadExibeDados>
                            <TableRowHeadExibeDados
                                dados={headList}
                            />
                        </TableHeadExibeDados>

                        <TableBodyExibeDados>
                            {estudo.current.aportePlanejadoAposentadoria?.map((item, ind) => {
                                return (
                                    <TableRowBodyExibeDados
                                        key={ind}
                                        report={reportPlanejadoAposentadoria}
                                    >
                                        <TableCellBodyExibeDados
                                            colSpan={headList[0].colSpan}
                                            primeiraColuna={true}
                                        >
                                            {formataTableCellBodyExibeDadosTexto(item.descricao, reportPlanejadoAposentadoria)}
                                        </TableCellBodyExibeDados>

                                        <TableCellBodyExibeDados
                                            colSpan={headList[1].colSpan}
                                        >
                                            {formataTableCellBodyExibeDadosTextoIdade(item.mesAnoInicialAporteDividendos,
                                                item.idadeInicialAporteDividendos, reportPlanejadoAposentadoria)}
                                        </TableCellBodyExibeDados>
                                        
                                        
                                        <TableCellBodyExibeDados
                                            colSpan={headList[2].colSpan}
                                        >
                                            {formataTableCellBodyExibeDadosTextoIdade(item.mesAnoFinalAporteDividendos,
                                                item.idadeFinalAporteDividendos, reportPlanejadoAposentadoria)}
                                        </TableCellBodyExibeDados>
                                        
                                        <TableCellBodyExibeDados
                                            colSpan={headList[3].colSpan}
                                        >
                                            {formataTableCellBodyExibeDadosTexto(item.descricaoTipoPeriodicidadeAporteDividendos,
                                                reportPlanejadoAposentadoria)}
                                        </TableCellBodyExibeDados>
                                        
                                        <TableCellBodyExibeDados
                                            colSpan={headList[4].colSpan}
                                        >
                                            {item.id === LABEL.economiaReceitaMensal
                                                ?
                                                    formataTableCellBodyExibeDadosPerc(
                                                        item.valorPercAporteDividendosContribuicao,
                                                            reportPlanejadoAposentadoria, false, false)
                                                :
                                                    formataTableCellBodyExibeDadosValor(item.valorPercAporteDividendosContribuicao,
                                                        reportPlanejadoAposentadoria, false, true)
                                            }
                                        </TableCellBodyExibeDados>
                                    </TableRowBodyExibeDados>
                                )
                            })}
                        </TableBodyExibeDados>
                    </TableExibeDados>
                </CardGridDivBody>
            </DivForm>
        )
    }



    return (
        <AportePlanejadoAposentadoria/>
    )
}

export default EstudoFormAportePlanejadoAposentadoria